// extracted by mini-css-extract-plugin
export default {"dot":"PatientDot_dot__Pbp7n"};